import { Pipe, PipeTransform } from '@angular/core';
import { IFTA_JURISDICTIONS } from '../../lib/ifta-jurisdictions';

@Pipe({ name: 'iftaJurisdiction' })
export class IftaJurisdictionPipe implements PipeTransform {
  public transform(abbr) {
    return IFTA_JURISDICTIONS[abbr];
  }
}
